export const CatalogDescription = () => {}
